import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Differentials } from "@/components/site/Differentials";
import { Portfolio } from "@/components/site/Portfolio";
import { SocialProof } from "@/components/site/SocialProof";
import { Reviews } from "@/components/site/Reviews";
import { ServiceArea } from "@/components/site/ServiceArea";
import { CTA } from "@/components/site/CTA";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";

function App() {
  useEffect(() => {
    const noLenis = new URLSearchParams(window.location.search).has("nolenis");
    if (noLenis) {
      const id = window.location.hash;
      if (id.length > 1) {
        let n = 0;
        const iv = setInterval(() => {
          const el = document.querySelector(id);
          if (el) el.scrollIntoView();
          if (++n > 40) clearInterval(iv);
        }, 80);
      }
      return;
    }
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-white antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Differentials />
        <Portfolio />
        <SocialProof />
        <Reviews />
        <ServiceArea />
        <CTA />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
